import React from 'react';
export const Hoverable = (context) => {
    const Component = ({ render }) => {
        const { isHovering } = React.useContext(context);
        return render(isHovering);
    };
    return Component;
};
//# sourceMappingURL=Hoverable.js.map